import { useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import { useRouter } from 'next/router';
import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';

import { useUserByWhereQuery } from '@/__generated__/public-graphql';
import DialogSwitcher from '@/contents/Dialogs/DialogSwitcher';
import BreadCrumb from '@/contents/General/BreadCrumb';
import Stack from '@/contents/General/Stack';
import { Footer } from '@/layouts/components/Footer';
import { Header } from '@/layouts/components/Header';
import { Container, PCArea } from '@/layouts/style';
import useGetLoginUser from '@/modules/User/user/useGetLoginUser';
import theme from '@/styles/theme';
import type { PublicUser } from '@/types/domain';

import { BottomMenu } from './components/BottomMenu';
import { CamperMenu } from './components/CamperMenu';
import { MypageMenu } from './components/MypageMenu';
import PCNavi from './components/PCNavi';
import PCSuggest from './components/PCSuggest';

type Props = {
  children: ReactNode;
  // bottommenu非表示
  noBottomMenu?: boolean;
  // mypageの上部メニュー非表示
  noMypageMenu?: boolean;
  hideFooter?: boolean;
};

const LayoutCamper = ({
  children,
  noBottomMenu,
  noMypageMenu,
  hideFooter,
}: Props) => {
  const router = useRouter();

  const isPC = useMediaQuery('(min-width:900px)');
  const urlId = router.query.id as string | undefined;

  // @ts-ignore
  const { props } = children;
  const { user: loginUser, isLogin } = useGetLoginUser();
  const { data } = useUserByWhereQuery({
    where: {
      id: {
        _eq: urlId ?? '0',
      },
    },
  });
  const publicUser = data?.user_public[0];
  const [user, setUser] = useState<PublicUser | null>(null);

  useEffect(() => {
    if (!user && publicUser) {
      setUser(publicUser);
    }
  }, [user, urlId, publicUser]);

  return (
    <>
      <Box>
        {isPC && (
          <PCArea>
            <Stack between>
              <PCNavi />
              <PCSuggest />
            </Stack>
          </PCArea>
        )}
        <Container>
          <Header />
          {loginUser && isLogin && urlId === loginUser.id && !noMypageMenu ? (
            <MypageMenu />
          ) : (
            user && !noMypageMenu && <CamperMenu user={user} />
          )}
          <main>
            {children}
            {!hideFooter && (
              <>
                <Box
                  sx={{
                    marginTop: 'auto',
                    marginBottom: theme.spacing(3),
                    padding: `${theme.spacing(10)} ${theme.spacing(3)} 0`,
                  }}
                >
                  <BreadCrumb campSite={props?.campSite} user={props?.user} />
                </Box>
                <Footer />
              </>
            )}
          </main>

          {!noBottomMenu && !isPC && <BottomMenu />}
          <DialogSwitcher />
        </Container>
      </Box>
    </>
  );
};

export default LayoutCamper;
